import React from 'react';
import { Container, Typography, Box, TextField } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';

const progress = 45; 
const step = 2; 

type PublishOutletContext = {
  handleNavigateToPropertyDescription: () => void;
  propertyTitle: string;
  setPropertyTitle: (propertyTitle: string) => void;
};

const PropertyTitlePage: React.FC = () => {
  const navigate = useNavigate();
  const { handleNavigateToPropertyDescription, propertyTitle, setPropertyTitle } = useOutletContext<PublishOutletContext>();

  const handleBack = () => {
    navigate(-1);
  };

  const handleContinue = () => {
    setPropertyTitle(propertyTitle);
    handleNavigateToPropertyDescription();
  };

  const charCount = propertyTitle.length;
  const maxLength = 32;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value;
    if (newTitle.length <= maxLength) {
      setPropertyTitle(newTitle);
    }
  };

  return (
    <Container maxWidth="md" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box mt={4} p={4} sx={{ width: '100%' }}>
        <Box sx={{ maxWidth: '600px', mx: 'auto', width: '100%' }}>
          <Typography variant="h4" gutterBottom>
            Ahora, ponle un título a tu propiedad
          </Typography>
          <Typography variant="body1" mb={4}>
            Los títulos cortos funcionan mejor. No te preocupes, puedes modificarlo más adelante.
          </Typography>

          <TextField
            label="Título de la propiedad"
            variant="outlined"
            fullWidth
            multiline
            rows={6}
            value={propertyTitle}
            onChange={handleChange}
            sx={{
              mb: 2,
              borderRadius: 2,
              '&:hover .MuiOutlinedInput-root': {
                border: '2px solid black',
              },
              '& .MuiOutlinedInput-root': {
                border: '2px solid grey',
                '&.Mui-focused fieldset': {
                  border: '2px solid black',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'grey',
                '&.Mui-focused': {
                  color: 'green',
                },
              },
            }}
          />
          <Typography variant="button" color="textSecondary" textAlign="right">
            {charCount}/{maxLength}
          </Typography>
        </Box>

        <PropertyFooterLayout
          progress={progress}
          step={step}
          onBack={handleBack}
          onContinue={handleContinue}
          isContinueDisabled={propertyTitle.trim().length === 0}
        />
      </Box>
      <Box
        sx={{
          height: "50px",
          display: { xs: "block", sm: "none" },
          width: "100%",
        }}
      />
    </Container>
  );
};

export default PropertyTitlePage;
